import axios from 'axios';
import store from '@/store';
import qs from 'qs';

const preBaseUrl = '/v2-api';
let uuid = localStorage.getItem('log_uuid');

if (!uuid) {
  uuid = getUuid();
  localStorage.setItem('log_uuid', uuid);
}

function getUuid() {
  const S4 = () => {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  };
  return S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4();
}

const request = axios.create({
  headers: {
    post: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    },
    'X-Requested-With': 'XMLHttpRequest',
    _client_uuid: uuid
  },
  timeout: 1000000,
  responseType: 'json'
});

// 请求发送前拦截器
request.interceptors.request.use(
  config => {
    const token = store.getters.token;
    if (token) {
      config.headers.Authorization = token;
    }

    if (config.method === 'get') {
      config.paramsSerializer = function(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      };
    }

    if (config.url.slice(0, 7) !== '/v2-api' && config.url.slice(0, 3) !== '/v4') {
      if (config.url.slice(0, 4) === '/nlp') {
        config.url = `/v4${config.url}`;
      } else {
        config.url = `${preBaseUrl}${config.url}`;
      }
    }

    return config;
  },
  err => {
    console.error(err);
  }
);

// 请求返回时处理
request.interceptors.response.use(
  res => {
    const resData = res.data;

    if (['blob', 'arraybuffer'].includes(res.config.responseType)) {
      return resData;
    }

    const { data, errCode, statusCode = 404, message = '数据请求失败' } = resData || {};

    if (errCode === 200) {
      return resData;
    }

    if (statusCode === 1) {
      return data;
    } else {
      const err = new Error(message || '请求出错');
      err.code = statusCode;
      err.requestInfo = res;

      if (statusCode === 309) {
        let replaceToLogin = true;
        if (sessionStorage.getItem('to_sentencing')) {
          replaceToLogin = false;
        }
        store.dispatch('logout', { replaceToLogin, sendEvent: false });
      }
      if (statusCode === 308) {
        err.message = '未绑定手机号';
      }
      throw err;
    }
  },
  err => {
    if (err.response) {
      err.code = err.response.status;
      err.requestInfo = err.response;
    } else {
      err.code = '接口报错连response都没有';
    }
    return Promise.reject(err);
  }
);

export default request;
